
import { useQuery } from 'react-query';

const useBusCollection = (page) => {
  const fetchBuses = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/vehicle/bus?page=${page}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch buses');
    }

    return response.json();
  };

  const { data: busData = {}, isLoading, isError } = useQuery(['charteredBus', page], fetchBuses);

  return { busData, isLoading, isError }; 
};

export default useBusCollection; 
